import React from 'react';
import classNames from 'classnames';

import AdvancedPlantingPlanFormContainer from 'planting-plan-form/AdvancedPlantingPlanFormContainer';

var baseString = 'vra-planting-plan';
var classString = classNames({
  [`${baseString}`]: true,
  'vra-create-script-screen': true
});

const PlantingPlan = () => (
  <section
    className={classString}
    data-test-id='create-script__choose'>
    <AdvancedPlantingPlanFormContainer />
  </section>
);
export default PlantingPlan;
